import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface WizardState {
  currentStep: number;
  deliveryAddress: string;
  paymentMethod: 'cash' | 'card' | 'mobile_money' | null;
  tableNumber: string;
  notes: string;
  isSubmitting: boolean;
  error: string | null;
}

const initialState: WizardState = {
  currentStep: 1,
  deliveryAddress: '',
  paymentMethod: null,
  tableNumber: '',
  notes: '',
  isSubmitting: false,
  error: null,
};

const wizardSlice = createSlice({
  name: 'wizard',
  initialState,
  reducers: {
    setStep: (state, action: PayloadAction<number>) => {
      state.currentStep = action.payload;
    },
    nextStep: (state) => {
      state.currentStep += 1;
    },
    prevStep: (state) => {
      if (state.currentStep > 1) {
        state.currentStep -= 1;
      }
    },
    updateFormData: (state, action: PayloadAction<Partial<Omit<WizardState, 'currentStep' | 'isSubmitting' | 'error'>>>) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    setSubmitting: (state, action: PayloadAction<boolean>) => {
      state.isSubmitting = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    resetWizard: () => initialState,
  },
});

export const {
  setStep,
  nextStep,
  prevStep,
  updateFormData,
  setSubmitting,
  setError,
  resetWizard,
} = wizardSlice.actions;

export default wizardSlice.reducer;
